import * as React from "react";
const SvgExpand = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871v7.317H3.38V4.438l3.107 3.11 3.11 3.107.529-.531.531-.53L7.55 6.487 4.439 3.38h4.748V1.87H5.53Zm12.942 0V3.38h4.748l-3.11 3.107-3.107 3.11.531.529.53.531 3.109-3.107 3.107-3.11v4.748h1.508V1.872H18.47ZM9.596 13.344l-3.11 3.107-3.107 3.11v-4.748H1.87v7.316h7.317V20.62H4.438l3.11-3.107 3.107-3.11-.531-.529Zm4.808 0-.529.531-.531.53 3.107 3.109 3.11 3.107h-4.748v1.508h7.316v-7.317H20.62V19.562l-3.107-3.11z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgExpand;
